/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RolesService {

    /**
     * Creates a role
     * @param xAccessToken API Token
     * @param requestBody
     * @returns any role created
     * @throws ApiError
     */
    public static postInternalApiWxRoles(
        xAccessToken?: string,
        requestBody?: {
            name: string;
            wx_external_id: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal_api/wx/roles',
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `unauthorized`,
                422: `invalid request`,
            },
        });
    }

    /**
     * Updates a role
     * @param wxExternalId Role WX External ID
     * @param xAccessToken API Token
     * @param requestBody
     * @returns any role updated
     * @throws ApiError
     */
    public static putInternalApiWxRoles(
        wxExternalId: string,
        xAccessToken?: string,
        requestBody?: {
            name: string;
            permissions?: any;
            system?: boolean | null;
            wx_external_id: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/internal_api/wx/roles/{wx_external_id}',
            path: {
                'wx_external_id': wxExternalId,
            },
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `role not found`,
                422: `invalid request`,
            },
        });
    }

    /**
     * Deletes a role
     * @param wxExternalId Role WX External ID
     * @param xAccessToken API Token
     * @returns void
     * @throws ApiError
     */
    public static deleteInternalApiWxRoles(
        wxExternalId: string,
        xAccessToken?: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/internal_api/wx/roles/{wx_external_id}',
            path: {
                'wx_external_id': wxExternalId,
            },
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            errors: {
                404: `role not found`,
            },
        });
    }

    /**
     * Gets role permissions
     * @param wxExternalId Role WX External ID
     * @param xAccessToken API Token
     * @returns any permissions retrieved
     * @throws ApiError
     */
    public static getInternalApiWxRolesPermissions(
        wxExternalId: string,
        xAccessToken?: string,
    ): CancelablePromise<{
        permissions?: any;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/wx/roles/permissions/{wx_external_id}',
            path: {
                'wx_external_id': wxExternalId,
            },
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            errors: {
                404: `role not found`,
            },
        });
    }

}